import React, { createContext, useState, useRef } from "react";
import Confirm from "../components/Confirm/Confirm";

export const ConfirmContext = createContext();

export function ConfirmProvider({ children }) {
  const [dialogState, setDialogState] = useState({
    isOpen: false,
    options: {},
  });
  const resolveRef = useRef(null);

  const confirm = (options = {}) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setDialogState({ isOpen: true, options });
    });
  };

  const closeDialog = () => {
    setDialogState((prev) => ({ ...prev, isOpen: false }));
    resolveRef.current = null;
  };

  const handleConfirm = () => {
    resolveRef.current?.(true); // Returns true to the caller
    closeDialog();
  };

  const handleCancel = () => {
    resolveRef.current?.(false); // Returns false to the caller
    closeDialog();
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {dialogState.isOpen && (
        <Confirm
          open={dialogState.isOpen}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          {...dialogState.options}
        />
      )}
    </ConfirmContext.Provider>
  );
}
